const STORES = [
    { context: 'ios', label: 'App Store', field: 'appStoreUrl' },
    { context: 'android', label: 'Google Play', field: 'googlePlayUrl' },
];
/**
 * Works out which store destinations an auto-store edit has to touch, keyed by
 * each destination's `publicId`.
 *
 * The edit form used to send the store URLs as the campaign PUT's whole
 * `trackingLinks` array. The server binds that collection by position, so any
 * other destination was deleted (a 500 once it had scans), and links in a
 * different order were overwritten onto each other (a 500 on the unique
 * label / URL keys). Going link by link leaves everything else alone.
 *
 * Clearing a store field deliberately does not delete its destination: that
 * would drop its scan history, and the destinations table already has delete.
 */
export function planAutoStoreLinkSync(existing, urls) {
    const changes = [];
    for (const store of STORES) {
        const targetUrl = (urls[store.field] ?? '').trim();
        if (targetUrl === '') {
            continue;
        }
        const current = existing.find((link) => link.context === store.context);
        if (current === undefined) {
            changes.push({
                kind: 'create',
                data: { label: store.label, targetUrl, type: 'url', context: store.context },
            });
        }
        else if (current.targetUrl !== targetUrl) {
            changes.push({
                kind: 'update',
                publicId: current.publicId,
                data: { label: current.label, targetUrl, type: current.type, context: current.context },
            });
        }
    }
    return changes;
}
